/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ERC721PresetMinterPauserAutoId,
  ERC721PresetMinterPauserAutoIdInterface,
} from "../ERC721PresetMinterPauserAutoId";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        internalType: "string",
        name: "baseTokenURI",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PAUSER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x60806040523480156200001157600080fd5b5060405162002c1038038062002c108339810160408190526200003491620003cc565b8251839083906200004d90600290602085019062000259565b5080516200006390600390602084019062000259565b5050600c805460ff191690555080516200008590600e90602084019062000259565b5062000093600033620000f4565b620000bf7f9f2df0fed2c77648de5860a4cc508cd0818c85b8b8a1ab4ceeef8d981c8956a633620000f4565b620000eb7f65d7a28e3265b37a6474929f336521b332c1681b933f6cb9f3376673440d862a33620000f4565b5050506200049a565b62000100828262000104565b5050565b6200011b82826200014760201b62000f4c1760201c565b60008281526001602090815260409091206200014291839062000fea620001e7821b17901c565b505050565b6000828152602081815260408083206001600160a01b038516845290915290205460ff1662000100576000828152602081815260408083206001600160a01b03851684529091529020805460ff19166001179055620001a33390565b6001600160a01b0316816001600160a01b0316837f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45050565b6000620001fe836001600160a01b03841662000207565b90505b92915050565b6000818152600183016020526040812054620002505750815460018181018455600084815260208082209093018490558454848252828601909352604090209190915562000201565b50600062000201565b82805462000267906200045d565b90600052602060002090601f0160209004810192826200028b5760008555620002d6565b82601f10620002a657805160ff1916838001178555620002d6565b82800160010185558215620002d6579182015b82811115620002d6578251825591602001919060010190620002b9565b50620002e4929150620002e8565b5090565b5b80821115620002e45760008155600101620002e9565b634e487b7160e01b600052604160045260246000fd5b600082601f8301126200032757600080fd5b81516001600160401b0380821115620003445762000344620002ff565b604051601f8301601f19908116603f011681019082821181831017156200036f576200036f620002ff565b816040528381526020925086838588010111156200038c57600080fd5b600091505b83821015620003b0578582018301518183018401529082019062000391565b83821115620003c25760008385830101525b9695505050505050565b600080600060608486031215620003e257600080fd5b83516001600160401b0380821115620003fa57600080fd5b620004088783880162000315565b945060208601519150808211156200041f57600080fd5b6200042d8783880162000315565b935060408601519150808211156200044457600080fd5b50620004538682870162000315565b9150509250925092565b600181811c908216806200047257607f821691505b602082108114156200049457634e487b7160e01b600052602260045260246000fd5b50919050565b61276680620004aa6000396000f3fe608060405234801561001057600080fd5b50600436106101e55760003560e01c80636352211e1161010f578063a22cb465116100a2578063d539139311610071578063d53913931461041b578063d547741f14610442578063e63ab1e914610455578063e985e9c51461047c57600080fd5b8063a22cb465146103cf578063b88d4fde146103e2578063c87b56dd146103f5578063ca15c8731461040857600080fd5b80639010d07c116100de5780639010d07c1461037557806391d148541461038857806395d89b41146103bf578063a217fddf146103c757600080fd5b80636352211e146103345780636a6278421461034757806370a082311461035a5780638456cb591461036d57600080fd5b80632f2ff15d1161018757806342842e0e1161015657806342842e0e146102f057806342966c68146103035780634f6ccce7146103165780635c975abb1461032957600080fd5b80632f2ff15d146102af5780632f745c59146102c257806336568abe146102d55780633f4ba83a146102e857600080fd5b8063095ea7b3116101c3578063095ea7b31461025257806318160ddd1461026757806323b872dd14610279578063248a9ca31461028c57600080fd5b806301ffc9a7146101ea57806306fdde0314610212578063081812fc14610227575b600080fd5b6101fd6101f8366004612231565b6104b8565b60405190151581526020015b60405180910390f35b61021a6104c9565b60405161020991906122a6565b61023a6102353660046122b9565b61055b565b6040516001600160a01b039091168152602001610209565b6102656102603660046122ee565b6105f5565b005b600a545b604051908152602001610209565b610265610287366004612318565b61070b565b61026b61029a3660046122b9565b60009081526020819052604090206001015490565b6102656102bd366004612354565b610793565b61026b6102d03660046122ee565b6107b9565b6102656102e3366004612354565b610861565b6102656108ed565b6102656102fe366004612318565b610995565b6102656103113660046122b9565b6109b0565b61026b6103243660046122b9565b610a37565b600c5460ff166101fd565b61023a6103423660046122b9565b610adb565b610265610355366004612380565b610b66565b61026b610368366004612380565b610c22565b610265610cbc565b61023a61038336600461239b565b610d60565b6101fd610396366004612354565b6000918252602082815260408084206001600160a01b0393909316845291905290205460ff1690565b61021a610d7f565b61026b600081565b6102656103dd3660046123bd565b610d8e565b6102656103f036600461240f565b610d99565b61021a6104033660046122b9565b610e27565b61026b6104163660046122b9565b610f0f565b61026b7f9f2df0fed2c77648de5860a4cc508cd0818c85b8b8a1ab4ceeef8d981c8956a681565b610265610450366004612354565b610f26565b61026b7f65d7a28e3265b37a6474929f336521b332c1681b933f6cb9f3376673440d862a81565b6101fd61048a3660046124eb565b6001600160a01b03918216600090815260076020908152604080832093909416825291909152205460ff1690565b60006104c382610fff565b92915050565b6060600280546104d890612515565b80601f016020809104026020016040519081016040528092919081815260200182805461050490612515565b80156105515780601f1061052657610100808354040283529160200191610551565b820191906000526020600020905b81548152906001019060200180831161053457829003601f168201915b5050505050905090565b6000818152600460205260408120546001600160a01b03166105d95760405162461bcd60e51b815260206004820152602c60248201527f4552433732313a20617070726f76656420717565727920666f72206e6f6e657860448201526b34b9ba32b73a103a37b5b2b760a11b60648201526084015b60405180910390fd5b506000908152600660205260409020546001600160a01b031690565b600061060082610adb565b9050806001600160a01b0316836001600160a01b0316141561066e5760405162461bcd60e51b815260206004820152602160248201527f4552433732313a20617070726f76616c20746f2063757272656e74206f776e656044820152603960f91b60648201526084016105d0565b336001600160a01b038216148061068a575061068a813361048a565b6106fc5760405162461bcd60e51b815260206004820152603860248201527f4552433732313a20617070726f76652063616c6c6572206973206e6f74206f7760448201527f6e6572206e6f7220617070726f76656420666f7220616c6c000000000000000060648201526084016105d0565b6107068383611024565b505050565b610716335b82611092565b6107885760405162461bcd60e51b815260206004820152603160248201527f4552433732313a207472616e736665722063616c6c6572206973206e6f74206f60448201527f776e6572206e6f7220617070726f76656400000000000000000000000000000060648201526084016105d0565b610706838383611189565b6000828152602081905260409020600101546107af8133611348565b61070683836113c6565b60006107c483610c22565b82106108385760405162461bcd60e51b815260206004820152602b60248201527f455243373231456e756d657261626c653a206f776e657220696e646578206f7560448201527f74206f6620626f756e647300000000000000000000000000000000000000000060648201526084016105d0565b506001600160a01b03919091166000908152600860209081526040808320938352929052205490565b6001600160a01b03811633146108df5760405162461bcd60e51b815260206004820152602f60248201527f416363657373436f6e74726f6c3a2063616e206f6e6c792072656e6f756e636560448201527f20726f6c657320666f722073656c66000000000000000000000000000000000060648201526084016105d0565b6108e982826113e8565b5050565b6109177f65d7a28e3265b37a6474929f336521b332c1681b933f6cb9f3376673440d862a33610396565b61098b576040805162461bcd60e51b81526020600482015260248101919091527f4552433732315072657365744d696e7465725061757365724175746f49643a2060448201527f6d75737420686176652070617573657220726f6c6520746f20756e706175736560648201526084016105d0565b61099361140a565b565b61070683838360405180602001604052806000815250610d99565b6109b933610710565b610a2b5760405162461bcd60e51b815260206004820152603060248201527f4552433732314275726e61626c653a2063616c6c6572206973206e6f74206f7760448201527f6e6572206e6f7220617070726f7665640000000000000000000000000000000060648201526084016105d0565b610a34816114a6565b50565b6000610a42600a5490565b8210610ab65760405162461bcd60e51b815260206004820152602c60248201527f455243373231456e756d657261626c653a20676c6f62616c20696e646578206f60448201527f7574206f6620626f756e6473000000000000000000000000000000000000000060648201526084016105d0565b600a8281548110610ac957610ac9612550565b90600052602060002001549050919050565b6000818152600460205260408120546001600160a01b0316806104c35760405162461bcd60e51b815260206004820152602960248201527f4552433732313a206f776e657220717565727920666f72206e6f6e657869737460448201527f656e7420746f6b656e000000000000000000000000000000000000000000000060648201526084016105d0565b610b907f9f2df0fed2c77648de5860a4cc508cd0818c85b8b8a1ab4ceeef8d981c8956a633610396565b610c025760405162461bcd60e51b815260206004820152603d60248201527f4552433732315072657365744d696e7465725061757365724175746f49643a2060448201527f6d7573742068617665206d696e74657220726f6c6520746f206d696e7400000060648201526084016105d0565b610c1481610c0f600d5490565b61154d565b610a34600d80546001019055565b60006001600160a01b038216610ca05760405162461bcd60e51b815260206004820152602a60248201527f4552433732313a2062616c616e636520717565727920666f7220746865207a6560448201527f726f20616464726573730000000000000000000000000000000000000000000060648201526084016105d0565b506001600160a01b031660009081526005602052604090205490565b610ce67f65d7a28e3265b37a6474929f336521b332c1681b933f6cb9f3376673440d862a33610396565b610d585760405162461bcd60e51b815260206004820152603e60248201527f4552433732315072657365744d696e7465725061757365724175746f49643a2060448201527f6d75737420686176652070617573657220726f6c6520746f207061757365000060648201526084016105d0565b61099361169b565b6000828152600160205260408120610d789083611723565b9392505050565b6060600380546104d890612515565b6108e933838361172f565b610da33383611092565b610e155760405162461bcd60e51b815260206004820152603160248201527f4552433732313a207472616e736665722063616c6c6572206973206e6f74206f60448201527f776e6572206e6f7220617070726f76656400000000000000000000000000000060648201526084016105d0565b610e21848484846117fe565b50505050565b6000818152600460205260409020546060906001600160a01b0316610eb45760405162461bcd60e51b815260206004820152602f60248201527f4552433732314d657461646174613a2055524920717565727920666f72206e6f60448201527f6e6578697374656e7420746f6b656e000000000000000000000000000000000060648201526084016105d0565b6000610ebe611887565b90506000815111610ede5760405180602001604052806000815250610d78565b80610ee884611896565b604051602001610ef9929190612566565b6040516020818303038152906040529392505050565b60008181526001602052604081206104c390611994565b600082815260208190526040902060010154610f428133611348565b61070683836113e8565b6000828152602081815260408083206001600160a01b038516845290915290205460ff166108e9576000828152602081815260408083206001600160a01b03851684529091529020805460ff19166001179055610fa63390565b6001600160a01b0316816001600160a01b0316837f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45050565b6000610d78836001600160a01b03841661199e565b60006001600160e01b0319821663780e9d6360e01b14806104c357506104c3826119ed565b600081815260066020526040902080546001600160a01b0319166001600160a01b038416908117909155819061105982610adb565b6001600160a01b03167f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b92560405160405180910390a45050565b6000818152600460205260408120546001600160a01b031661110b5760405162461bcd60e51b815260206004820152602c60248201527f4552433732313a206f70657261746f7220717565727920666f72206e6f6e657860448201526b34b9ba32b73a103a37b5b2b760a11b60648201526084016105d0565b600061111683610adb565b9050806001600160a01b0316846001600160a01b031614806111515750836001600160a01b03166111468461055b565b6001600160a01b0316145b8061118157506001600160a01b0380821660009081526007602090815260408083209388168352929052205460ff165b949350505050565b826001600160a01b031661119c82610adb565b6001600160a01b0316146112185760405162461bcd60e51b815260206004820152602960248201527f4552433732313a207472616e73666572206f6620746f6b656e2074686174206960448201527f73206e6f74206f776e000000000000000000000000000000000000000000000060648201526084016105d0565b6001600160a01b03821661127a5760405162461bcd60e51b8152602060048201526024808201527f4552433732313a207472616e7366657220746f20746865207a65726f206164646044820152637265737360e01b60648201526084016105d0565b611285838383611a2d565b611290600082611024565b6001600160a01b03831660009081526005602052604081208054600192906112b99084906125ab565b90915550506001600160a01b03821660009081526005602052604081208054600192906112e79084906125c2565b909155505060008181526004602052604080822080546001600160a01b0319166001600160a01b0386811691821790925591518493918716917fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef91a4505050565b6000828152602081815260408083206001600160a01b038516845290915290205460ff166108e957611384816001600160a01b03166014611a38565b61138f836020611a38565b6040516020016113a09291906125da565b60408051601f198184030181529082905262461bcd60e51b82526105d0916004016122a6565b6113d08282610f4c565b60008281526001602052604090206107069082610fea565b6113f28282611be1565b60008281526001602052604090206107069082611c60565b600c5460ff1661145c5760405162461bcd60e51b815260206004820152601460248201527f5061757361626c653a206e6f742070617573656400000000000000000000000060448201526064016105d0565b600c805460ff191690557f5db9ee0a495bf2e6ff9c91a7834c1ba4fdd244a5e8aa4e537bd38aeae4b073aa335b6040516001600160a01b03909116815260200160405180910390a1565b60006114b182610adb565b90506114bf81600084611a2d565b6114ca600083611024565b6001600160a01b03811660009081526005602052604081208054600192906114f39084906125ab565b909155505060008281526004602052604080822080546001600160a01b0319169055518391906001600160a01b038416907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef908390a45050565b6001600160a01b0382166115a35760405162461bcd60e51b815260206004820181905260248201527f4552433732313a206d696e7420746f20746865207a65726f206164647265737360448201526064016105d0565b6000818152600460205260409020546001600160a01b0316156116085760405162461bcd60e51b815260206004820152601c60248201527f4552433732313a20746f6b656e20616c7265616479206d696e7465640000000060448201526064016105d0565b61161460008383611a2d565b6001600160a01b038216600090815260056020526040812080546001929061163d9084906125c2565b909155505060008181526004602052604080822080546001600160a01b0319166001600160a01b03861690811790915590518392907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef908290a45050565b600c5460ff16156116ee5760405162461bcd60e51b815260206004820152601060248201527f5061757361626c653a207061757365640000000000000000000000000000000060448201526064016105d0565b600c805460ff191660011790557f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a2586114893390565b6000610d788383611c75565b816001600160a01b0316836001600160a01b031614156117915760405162461bcd60e51b815260206004820152601960248201527f4552433732313a20617070726f766520746f2063616c6c65720000000000000060448201526064016105d0565b6001600160a01b03838116600081815260076020908152604080832094871680845294825291829020805460ff191686151590811790915591519182527f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31910160405180910390a3505050565b611809848484611189565b61181584848484611c9f565b610e215760405162461bcd60e51b815260206004820152603260248201527f4552433732313a207472616e7366657220746f206e6f6e20455243373231526560448201527f63656976657220696d706c656d656e746572000000000000000000000000000060648201526084016105d0565b6060600e80546104d890612515565b6060816118ba5750506040805180820190915260018152600360fc1b602082015290565b8160005b81156118e457806118ce8161265b565b91506118dd9050600a8361268c565b91506118be565b60008167ffffffffffffffff8111156118ff576118ff6123f9565b6040519080825280601f01601f191660200182016040528015611929576020820181803683370190505b5090505b84156111815761193e6001836125ab565b915061194b600a866126a0565b6119569060306125c2565b60f81b81838151811061196b5761196b612550565b60200101906001600160f81b031916908160001a90535061198d600a8661268c565b945061192d565b60006104c3825490565b60008181526001830160205260408120546119e5575081546001818101845560008481526020808220909301849055845484825282860190935260409020919091556104c3565b5060006104c3565b60006001600160e01b031982166380ac58cd60e01b1480611a1e57506001600160e01b03198216635b5e139f60e01b145b806104c357506104c382611e02565b610706838383611e27565b60606000611a478360026126b4565b611a529060026125c2565b67ffffffffffffffff811115611a6a57611a6a6123f9565b6040519080825280601f01601f191660200182016040528015611a94576020820181803683370190505b509050600360fc1b81600081518110611aaf57611aaf612550565b60200101906001600160f81b031916908160001a905350600f60fb1b81600181518110611ade57611ade612550565b60200101906001600160f81b031916908160001a9053506000611b028460026126b4565b611b0d9060016125c2565b90505b6001811115611b92577f303132333435363738396162636465660000000000000000000000000000000085600f1660108110611b4e57611b4e612550565b1a60f81b828281518110611b6457611b64612550565b60200101906001600160f81b031916908160001a90535060049490941c93611b8b816126d3565b9050611b10565b508315610d785760405162461bcd60e51b815260206004820181905260248201527f537472696e67733a20686578206c656e67746820696e73756666696369656e7460448201526064016105d0565b6000828152602081815260408083206001600160a01b038516845290915290205460ff16156108e9576000828152602081815260408083206001600160a01b0385168085529252808320805460ff1916905551339285917ff6391f5c32d9c69d2a47ea670b442974b53935d1edc7fd64eb21e047a839171b9190a45050565b6000610d78836001600160a01b038416611eab565b6000826000018281548110611c8c57611c8c612550565b9060005260206000200154905092915050565b60006001600160a01b0384163b15611df757604051630a85bd0160e11b81526001600160a01b0385169063150b7a0290611ce39033908990889088906004016126ea565b602060405180830381600087803b158015611cfd57600080fd5b505af1925050508015611d2d575060408051601f3d908101601f19168201909252611d2a91810190612726565b60015b611ddd573d808015611d5b576040519150601f19603f3d011682016040523d82523d6000602084013e611d60565b606091505b508051611dd55760405162461bcd60e51b815260206004820152603260248201527f4552433732313a207472616e7366657220746f206e6f6e20455243373231526560448201527f63656976657220696d706c656d656e746572000000000000000000000000000060648201526084016105d0565b805181602001fd5b6001600160e01b031916630a85bd0160e11b149050611181565b506001949350505050565b60006001600160e01b03198216635a05180f60e01b14806104c357506104c382611f9e565b611e32838383611fd3565b600c5460ff16156107065760405162461bcd60e51b815260206004820152602b60248201527f4552433732315061757361626c653a20746f6b656e207472616e73666572207760448201527f68696c652070617573656400000000000000000000000000000000000000000060648201526084016105d0565b60008181526001830160205260408120548015611f94576000611ecf6001836125ab565b8554909150600090611ee3906001906125ab565b9050818114611f48576000866000018281548110611f0357611f03612550565b9060005260206000200154905080876000018481548110611f2657611f26612550565b6000918252602080832090910192909255918252600188019052604090208390555b8554869080611f5957611f59612743565b6001900381819060005260206000200160009055905585600101600086815260200190815260200160002060009055600193505050506104c3565b60009150506104c3565b60006001600160e01b03198216637965db0b60e01b14806104c357506301ffc9a760e01b6001600160e01b03198316146104c3565b6001600160a01b03831661202e5761202981600a80546000838152600b60205260408120829055600182018355919091527fc65a7bb8d6351c1cf70c95a316cc6a92839c986682d98bc35f958f4883f9d2a80155565b612051565b816001600160a01b0316836001600160a01b03161461205157612051838261208b565b6001600160a01b0382166120685761070681612128565b826001600160a01b0316826001600160a01b0316146107065761070682826121d7565b6000600161209884610c22565b6120a291906125ab565b6000838152600960205260409020549091508082146120f5576001600160a01b03841660009081526008602090815260408083208584528252808320548484528184208190558352600990915290208190555b5060009182526009602090815260408084208490556001600160a01b039094168352600881528383209183525290812055565b600a5460009061213a906001906125ab565b6000838152600b6020526040812054600a805493945090928490811061216257612162612550565b9060005260206000200154905080600a838154811061218357612183612550565b6000918252602080832090910192909255828152600b9091526040808220849055858252812055600a8054806121bb576121bb612743565b6001900381819060005260206000200160009055905550505050565b60006121e283610c22565b6001600160a01b039093166000908152600860209081526040808320868452825280832085905593825260099052919091209190915550565b6001600160e01b031981168114610a3457600080fd5b60006020828403121561224357600080fd5b8135610d788161221b565b60005b83811015612269578181015183820152602001612251565b83811115610e215750506000910152565b6000815180845261229281602086016020860161224e565b601f01601f19169290920160200192915050565b602081526000610d78602083018461227a565b6000602082840312156122cb57600080fd5b5035919050565b80356001600160a01b03811681146122e957600080fd5b919050565b6000806040838503121561230157600080fd5b61230a836122d2565b946020939093013593505050565b60008060006060848603121561232d57600080fd5b612336846122d2565b9250612344602085016122d2565b9150604084013590509250925092565b6000806040838503121561236757600080fd5b82359150612377602084016122d2565b90509250929050565b60006020828403121561239257600080fd5b610d78826122d2565b600080604083850312156123ae57600080fd5b50508035926020909101359150565b600080604083850312156123d057600080fd5b6123d9836122d2565b9150602083013580151581146123ee57600080fd5b809150509250929050565b634e487b7160e01b600052604160045260246000fd5b6000806000806080858703121561242557600080fd5b61242e856122d2565b935061243c602086016122d2565b925060408501359150606085013567ffffffffffffffff8082111561246057600080fd5b818701915087601f83011261247457600080fd5b813581811115612486576124866123f9565b604051601f8201601f19908116603f011681019083821181831017156124ae576124ae6123f9565b816040528281528a60208487010111156124c757600080fd5b82602086016020830137600060208483010152809550505050505092959194509250565b600080604083850312156124fe57600080fd5b612507836122d2565b9150612377602084016122d2565b600181811c9082168061252957607f821691505b6020821081141561254a57634e487b7160e01b600052602260045260246000fd5b50919050565b634e487b7160e01b600052603260045260246000fd5b6000835161257881846020880161224e565b83519083019061258c81836020880161224e565b01949350505050565b634e487b7160e01b600052601160045260246000fd5b6000828210156125bd576125bd612595565b500390565b600082198211156125d5576125d5612595565b500190565b7f416363657373436f6e74726f6c3a206163636f756e742000000000000000000081526000835161261281601785016020880161224e565b7f206973206d697373696e6720726f6c6520000000000000000000000000000000601791840191820152835161264f81602884016020880161224e565b01602801949350505050565b600060001982141561266f5761266f612595565b5060010190565b634e487b7160e01b600052601260045260246000fd5b60008261269b5761269b612676565b500490565b6000826126af576126af612676565b500690565b60008160001904831182151516156126ce576126ce612595565b500290565b6000816126e2576126e2612595565b506000190190565b60006001600160a01b0380871683528086166020840152508360408301526080606083015261271c608083018461227a565b9695505050505050565b60006020828403121561273857600080fd5b8151610d788161221b565b634e487b7160e01b600052603160045260246000fdfea164736f6c6343000809000a";

type ERC721PresetMinterPauserAutoIdConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ERC721PresetMinterPauserAutoIdConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ERC721PresetMinterPauserAutoId__factory extends ContractFactory {
  constructor(...args: ERC721PresetMinterPauserAutoIdConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    name: string,
    symbol: string,
    baseTokenURI: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC721PresetMinterPauserAutoId> {
    return super.deploy(
      name,
      symbol,
      baseTokenURI,
      overrides || {}
    ) as Promise<ERC721PresetMinterPauserAutoId>;
  }
  getDeployTransaction(
    name: string,
    symbol: string,
    baseTokenURI: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      name,
      symbol,
      baseTokenURI,
      overrides || {}
    );
  }
  attach(address: string): ERC721PresetMinterPauserAutoId {
    return super.attach(address) as ERC721PresetMinterPauserAutoId;
  }
  connect(signer: Signer): ERC721PresetMinterPauserAutoId__factory {
    return super.connect(signer) as ERC721PresetMinterPauserAutoId__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC721PresetMinterPauserAutoIdInterface {
    return new utils.Interface(_abi) as ERC721PresetMinterPauserAutoIdInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC721PresetMinterPauserAutoId {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ERC721PresetMinterPauserAutoId;
  }
}
